import { createReducer } from "redux-create-reducer";

import {
  SCORE_CARD_CALCULATE,
  SCORE_CARD_CALCULATE_CLEAR,
} from "../types/scoreCardCalculate";

const initialState = {
  isLoading: false,
  submitSuccess: false,
};

const scoreCardCalculateReducer = createReducer(initialState, {
  [SCORE_CARD_CALCULATE.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
    submitSuccess: false,
  }),
  [SCORE_CARD_CALCULATE.PENDING]: (state) => ({
    ...state,
    isLoading: true,
    submitSuccess: false,
  }),
  [SCORE_CARD_CALCULATE.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
    submitSuccess: false,
  }),
  [SCORE_CARD_CALCULATE.FULFILLED]: (state) => ({
    ...state,
    isLoading: false,
    submitSuccess: true,
  }),
  [SCORE_CARD_CALCULATE_CLEAR]: (state) => ({
    ...state,
    submitSuccess: !state.submitSuccess,
  }),
});

export default scoreCardCalculateReducer;



// WEBPACK FOOTER //
// ./src/features/score-card/reducers/scoreCardCalculateReducer.js